import React from 'react';
import { LazyPicture } from '@catalogo/theme-lazy-picture';
import styled from 'styled-components';
import Video from './video';

export const MainImg = ({ selectedImage, handleClick, disabled, alt }) => {
  if (selectedImage.video) {
    return <Container>{selectedImage.video && <Video url={selectedImage.video} />}</Container>;
  }

  return (
    <Container onClick={handleClick} disabled={disabled}>
      <LazyPicture
        sources={{
          mobile: {
            src: selectedImage.main,
            ratio: '1:1',
          },
        }}
        lazy={false}
        alt={alt}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  mix-blend-mode: multiply;

  &[disabled] {
    pointer-events: none;
  }
`;

export default MainImg;
